"use client";

import { EdgenModalCreateAble } from "@/src/components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@/src/components/EdgenModal/waitForEdgenModalRoot";
import { LoadingOnboardingModalContent } from "./LoadingOnboardingModalContent";
import type {
  LoadingModalAction,
  OpenLoadingOnboardingModalParams,
} from "./types";

type LoadingModalResult = { action: LoadingModalAction };

let pendingLoadingModal: Promise<LoadingModalResult> | null = null;

/**
 * Onboarding loading — H5 fullscreen / PC centered modal (Figma `88960:41231`).
 */
export const openLoadingOnboardingModal = (
  params: OpenLoadingOnboardingModalParams = {},
): Promise<LoadingModalResult> => {
  if (pendingLoadingModal) {
    return pendingLoadingModal;
  }

  pendingLoadingModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<LoadingModalResult>((resolve) => {
        let settled = false;
        const finish = (action: LoadingModalAction) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingLoadingModal = null;
          EdgenModalCreateAble.end(false);
          params.onBack?.();
          resolve({ action });
        };

        EdgenModalCreateAble.call({
          children: (
            <LoadingOnboardingModalContent
              ringPeakOpacity={0.3}
              onClose={(action = "back") => {
                finish(action);
              }}
            />
          ),
          className:
            "[--modal-radius:0px] md:[--modal-radius:24px] [--modal-height:100dvh] md:[--modal-height:min(852px,90vh)] md:[--modal-width:393px] [--modal-width:100%]",
          contentStyle: {
            borderRadius: "var(--modal-radius)",
            width: "var(--modal-width)",
            height: "var(--modal-height)",
            overflow: "hidden",
            padding: 0,
          },
          styles: {
            body: {
              height: "100%",
            },
          },
          containerStyle: {
            height: "100%",
            width: "100%",
            maxHeight: "100%",
          },
          titleStyle: {
            minHeight: 0,
          },
          showClose: false,
          maskClosable: false,
          destroyOnClose: true,
        });
      }),
  ).catch((error) => {
    pendingLoadingModal = null;
    throw error;
  });

  return pendingLoadingModal;
};
